module.exports = __webpack_public_path__ + "static/img/1.d643cd4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/sp/1.png
// module id = jClE
// module chunks = 0